import React from 'react';
import { Modal } from 'react-bootstrap';

export function PaymentModal(props) {
  console.log(props);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body style={{ 'height': 'calc(100vh - 210px)', padding: 0 }}>
        <iframe title="get_request_token" style={{ 'height': '100%', 'width': '100%' }} src={props.z_credit_url} />

      </Modal.Body>

    </Modal>
  );
}
